import { Question } from "./types";

const data: Question[] = [
  {
    question: "Does it cost anything to use your travel planning services?",
    answer: [
      "In most cases, no. Our planning services are complimentary because we are compensated by many of the hotels, resorts, cruise lines, and travel suppliers we work with.",
      "When a supplier does not offer commission or a trip requires extensive custom planning, we'll always discuss any planning fees with you before moving forward. There are never any surprise charges.",
    ],
  },
  {
    question: "Will I pay more than if I book online myself?",
    answer: [
      "No. In many cases, you'll pay the same price as booking directly, and sometimes we can even find exclusive promotions, added amenities, or extra value through our travel partners.",
      "Our goal is to help you make the most of your vacation while saving you time and avoiding costly mistakes.",
    ],
  },
  {
    question: "How does the planning process work?",
    answer: [
      "It all starts with a quote request or consultation. We'll learn about your travel style, budget, interests, and priorities before researching the best options for your trip.",
      "Once you've reviewed your personalized recommendations, we'll handle the booking process, keep track of important deadlines, and remain available before and during your travels.",
    ],
  },
  {
    question: "When do I pay for my vacation?",
    answer: [
      "Many vacations only require an initial deposit to reserve your trip, with the remaining balance due closer to your departure date.",
      "Some travel products, such as airfare, often require full payment at the time of booking. We'll explain all payment requirements before you confirm your reservation.",
    ],
  },
  {
    question: "How are my vacation payments handled?",
    answer: [
      "Payments are typically processed directly through the travel supplier, such as the cruise line, resort, hotel, or tour operator.",
      "This means your reservation and payments are made directly with the company providing your vacation, giving you added peace of mind.",
    ],
  },
  {
    question: "Can you help if I don't know where I want to go?",
    answer: [
      "Absolutely! One of our favorite parts of planning is helping travelers discover destinations that fit their interests, travel style, and budget.",
      "Whether you're dreaming of a relaxing beach vacation, an adventurous itinerary, or a once-in-a-lifetime honeymoon, we'll help narrow down the perfect options.",
    ],
  },
  {
    question: "Can you book airfare, hotels, cruises, and excursions?",
    answer: [
      "Yes! We can coordinate nearly every aspect of your vacation, including flights, hotels, all-inclusive resorts, cruises, airport transfers, excursions, travel insurance, and more.",
      "Our goal is to create a seamless travel experience from departure to your return home.",
    ],
  },
  {
    question: "Do you recommend travel insurance?",
    answer: [
      "Yes. We highly recommend protecting your vacation investment with travel insurance.",
      "Travel protection can help cover unexpected situations such as trip cancellations, medical emergencies, delays, lost luggage, and more. We'll discuss the available options so you can choose the coverage that's right for you.",
    ],
  },
  {
    question: "What happens if something changes while I'm traveling?",
    answer: [
      "Unexpected situations can happen, and we're here to help whenever possible.",
      "If your itinerary changes or you encounter travel-related issues, we'll help resolve problems and get your vacation back on track.",
    ],
  },
  {
    question: "Can you help with destination weddings and group travel?",
    answer: [
      "Absolutely! We specialize in destination weddings, family reunions, corporate retreats, and other group vacations.",
      "We'll coordinate accommodations, travel arrangements, and supplier communication so your group can focus on enjoying the experience together.",
    ],
  },
  {
    question: "Do you only book luxury vacations?",
    answer: [
      "Not at all. We work with travelers across a wide range of budgets and travel styles.",
      "Whether you're planning a weekend getaway, a family vacation, an all-inclusive resort stay, or a luxury escape, we'll help you find the best value for your budget.",
    ],
  },
  {
    question: "How far in advance should I book my vacation?",
    answer: [
      "The earlier, the better. Booking several months in advance typically provides the best selection of resorts, cruise cabins, flights, and promotional offers.",
      "However, we can also help with last-minute vacations whenever availability allows.",
    ],
  },
  {
    question: "Can you accommodate special requests?",
    answer: [
      "Yes. Whether you have dietary requirements, mobility needs, accessibility requests, room preferences, or are celebrating a special occasion, we'll work with our travel partners to accommodate your needs whenever possible.",
    ],
  },
  {
    question: "Why should I use a travel advisor instead of booking online?",
    answer: [
      "Online booking websites are great at showing prices, but they can't get to know you.",
      "We provide personalized recommendations, expert guidance, ongoing support, and help navigating the countless options available. Our goal is to save you time, reduce stress, and help you enjoy a vacation that's perfectly suited to you.",
    ],
  },
  {
    question: "What if I still have questions?",
    answer: [
      "We're always happy to help. If you don't see your question answered here, simply reach out through our contact page and we'll be happy to answer any questions you have before, during, or after planning your vacation.",
    ],
  },
];

export default data;
